import React, { useRef } from "react";
import "./CustomerSlider.css";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore from "swiper/core";
import "swiper/swiper-bundle.css";
import { Box, Typography } from "@mui/material";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";
import ImageBottomBanner from "../../assets/images/ImageflowerBanner.png";
import LeftArrow from "../../assets/icons/LeftArrowImage.png";
import RightArrow from "../../assets/icons/RightArrowImage.png";
import Orangelogo from "../../assets/images/Orangelogo.png";
import UserGroup from "../../assets/images/image 14.png";
import Rating from "../../assets/images/Group 18624.png";
import GraphicImage from "../../assets/images/AbstractImg.png";

SwiperCore.use([Navigation]);

function CustomerSlider() {
  const swiperRef = useRef(null);

  const goPrev = () => {
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slidePrev();
    }
  };

  const goNext = () => {
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slideNext();
    }
  };

  return (
    <Box>
      <Box
        sx={{
          width: "100%",
          marginTop: "2rem",
          display: "flex",
          justifyContent: "center",
          flexDirection: { xs: "column", sm: "column" },
          padding: { xs: "0rem 1.8rem", sm: "0rem 3rem" },
          backgroundColor: "#ecebeb",
          alignContent: "center",
          marginBottom: "2rem",
        }}
      >
        <Box
          sx={{
            margin: "0 auto",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignContent: "center",
          }}
        >
          <Box
            sx={{
              width: "4rem",
              margin: "0 auto",

              marginTop: { xs: "4rem", sm: "2rem" },
            }}
          >
            <img src={Orangelogo} alt="" width="100%" />
          </Box>
          <Typography
            sx={{
              color: "rgba(35, 35, 37, 1)",
              fontFamily: "Montserrat",
              fontSize: { xs: "0.8rem", sm: "1rem" },
              marginTop: "0.8rem",
              textAlign: "center",
            }}
          >
            WHAT OUR CLIENTS HAVE TO SAY ABOUT US
          </Typography>
          <Typography
            variant="h4"
            sx={{
              fontFamily: "Montserrat",
              fontSize: { xs: "1.4rem", sm: "1.6rem" },
              fontWeight: "500",
              marginTop: "1.2rem",
              textAlign: "center",
            }}
          >
            <span style={{ color: "rgba(255, 102, 0, 1)" }}>Testimonials</span>
          </Typography>
        </Box>

        <Box
          sx={{
            width: "100%",
          }}
        ></Box>
      </Box>

      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            width: "100%",
            zIndex: "0",
          }}
        >
          <img src={GraphicImage} alt="" width="100%" />
        </Box>

        <Box>
          <button
            className="custom-prev-buttonn portfolio-btn-btnn"
            onClick={goPrev}
          >
            <Box
              sx={{
                width: { xs: "2.6rem", sm: "3rem" },
                zIndex: "1",
              }}
            >
              <img src={LeftArrow} alt="" width="100%" />
            </Box>
          </button>
        </Box>

        <Box
          sx={{
            width: { xs: "17rem", sm: "32rem", md: "75rem" },
            height: { xs: "auto", sm: "auto" },
            borderRadius: "1rem",
            position: "relative",
          }}
        >
          <div className="Homeportfolio-crousel">
            <div className="swiper-mainTwo">
              <Swiper
                ref={swiperRef}
                spaceBetween={20}
                slidesPerView={1}
                centeredSlides={true}
                loop={true}
                navigation={{
                  nextEl: ".custom-next-buttonn",
                  prevEl: ".custom-prev-buttonn",
                }}
                breakpoints={{
                  0: {
                    slidesPerView: 1,
                    loop: true,
                    centeredSlides: true,
                  },
                  740: {
                    slidesPerView: 1,
                    loop: true,
                    centeredSlides: true,
                  },
                  1024: {
                    slidesPerView: 1,
                    loop: true,
                    centeredSlides: true,
                  },
                }}
              >
                <SwiperSlide>
                  <Box
                    sx={{
                      width: { xs: "90%", sm: "90%" },
                      height: { xs: "44rem", sm: "50.5rem", md: "36.5rem" },
                      overflow: "visible",
                      borderRadius: "1rem",
                      backgroundColor: "rgba(241, 241, 241, 1)",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      position: "relative",
                      margin: "0 auto",
                    }}
                  >
                    <Box
                      sx={{
                        width: { xs: "90%", sm: "90%" },
                        padding: { xs: "1rem 0rem", sm: "2.5rem 0rem" },
                      }}
                    >
                      <Typography
                        sx={{
                          textAlign: "left",
                          fontFamily: "Plus Jakarta Sans",
                          fontWeight: "300",
                          fontSize: { xs: "0.7rem", sm: "1rem" },
                        }}
                      >
                        Working with Prasun and the Inteliphyle team was a great
                        experience. The challenge we undertook was moving into
                        unknown terrain, piecing together a puzzle - literally
                        and figuratively.
                        <br />
                        <br />
                        Prasun curated a diverse set of experts from different
                        domains to answer the challenge with depth, rigour and
                        diversity of perspective. The outcome and insight was -
                        unsurprisingly - rich and accurate.
                        <br />
                        <br />
                        Was one of great learning for me and the Brand team who
                        worked collaboratively with the Inteliphyle team - a
                        team of go-getters indeed who delivered it in record
                        time
                        <br />
                        <br />
                      </Typography>
                      <Typography
                        sx={{
                          color: "rgba(255, 102, 0, 1)",
                          fontSize: { xs: "0.8rem", sm: "1.1rem" },
                          fontWeight: "500",
                          paddingTop: "0.8rem",
                        }}
                      >
                        Chief Marketing Officer - Marico Bangladesh
                      </Typography>
                    </Box>
                  </Box>
                </SwiperSlide>

                <SwiperSlide>
                  <Box
                    sx={{
                      width: { xs: "90%", sm: "90%" },
                      height: { xs: "44rem", sm: "50.5rem", md: "36.5rem" },
                      overflow: "visible",
                      borderRadius: "1rem",
                      backgroundColor: "rgba(241, 241, 241, 1)",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      position: "relative",
                      margin: "0 auto",
                    }}
                  >
                    <Box
                      sx={{
                        width: { xs: "90%", sm: "90%" },
                        padding: { xs: "1rem 0rem", sm: "2.5rem 0rem" },
                      }}
                    >
                      <Typography
                        sx={{
                          textAlign: "left",
                          fontFamily: "Plus Jakarta Sans",
                          fontWeight: "300",
                          fontSize: { xs: "0.7rem", sm: "1rem" },
                        }}
                      >
                        Dear Inteliphyle team,
                        <br />
                        <br />
                        We knew you were the right team to pull off this
                        workshop with diverse stakeholders.
                        <br />
                        <br />
                        Thanks for executing with excellence. Hope this session
                        helps us make more meaningful business decision in
                        months to come.
                        <br />
                        <br />
                        And I hope a massive learning happened across functions
                        today.
                        <br />
                        <br />
                      </Typography>
                      <Typography
                        sx={{
                          color: "rgba(255, 102, 0, 1)",
                          fontSize: { xs: "0.8rem", sm: "1.1rem" },
                          fontWeight: "500",
                          paddingTop: "0.8rem",
                        }}
                      >
                        Head of Strategic Insights - JTI
                      </Typography>
                    </Box>
                  </Box>
                </SwiperSlide>

                <SwiperSlide>
                  <Box
                    sx={{
                      width: { xs: "90%", sm: "90%" },
                      height: { xs: "44rem", sm: "50.5rem", md: "36.5rem" },
                      overflow: "visible",
                      borderRadius: "1rem",
                      backgroundColor: "rgba(241, 241, 241, 1)",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      position: "relative",
                      margin: "0 auto",
                    }}
                  >
                    <Box
                      sx={{
                        width: { xs: "90%", sm: "90%" },
                        padding: { xs: "1rem 0rem", sm: "2.5rem 0rem" },
                      }}
                    >
                      <Typography
                        sx={{
                          textAlign: "left",
                          fontFamily: "Plus Jakarta Sans",
                          fontWeight: "300",
                          fontSize: { xs: "0.7rem", sm: "1rem" },
                        }}
                      >
                        Dear Inteliphyle Team,
                        <br />
                        <br />
                        I trust this email finds you well. I am writing to
                        express my sincere appreciation for the outstanding work
                        your team has delivered in our recent analytics pilot
                        project focused on holistic brand growth.
                        <br />
                        <br />
                        The dashboard employing push and pull metrics, coupled
                        with the implementation of a balanced scorecard, has
                        proven to be an impactful tool. Your dedication to
                        identifying each brand's optimal blend of push and pull
                        factors and subsequently mapping the regions on the
                        push-pull spectrum has provided us with actionable
                        insights that are already proven to be used in shaping
                        our strategic decisions.
                        <br />
                        <br />
                        The clarity and depth of the findings have not only
                        impressed our internal team but have also garnered
                        positive feedback from stakeholders. We eagerly
                        anticipate the opportunity to collaborate and explore
                        further opportunities for strategic partnerships.
                        <br />
                        <br />
                        Once again, thank you for your unwavering commitment to
                        excellence and for playing a pivotal role in providing a
                        statistical model that can drive our brand growth
                        strategy forward.
                        <br />
                        <br />
                        Best Regards
                        <br />
                      </Typography>
                      <Typography
                        sx={{
                          color: "rgba(255, 102, 0, 1)",
                          fontSize: { xs: "0.8rem", sm: "1.1rem" },
                          fontWeight: "500",
                          paddingTop: "0.8rem",
                        }}
                      >
                        Parvez Hossain - JTI
                      </Typography>
                    </Box>
                  </Box>
                </SwiperSlide>

                <SwiperSlide>
                  <Box
                    sx={{
                      width: { xs: "90%", sm: "90%" },
                      height: { xs: "44rem", sm: "50.5rem", md: "36.5rem" },

                      overflow: "visible",
                      borderRadius: "1rem",
                      backgroundColor: "rgba(241, 241, 241, 1)",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      position: "relative",
                      margin: "0 auto",
                    }}
                  >
                    <Box
                      sx={{
                        width: { xs: "90%", sm: "90%" },
                        padding: { xs: "1rem 0rem", sm: "2.5rem 0rem" },
                      }}
                    >
                      <Typography
                        sx={{
                          textAlign: "left",
                          fontFamily: "Plus Jakarta Sans",
                          fontWeight: "300",
                          fontSize: { xs: "0.7rem", sm: "1rem" },
                        }}
                      >
                        Dear Prasun,
                        <br />
                        <br />
                        I hope this email finds you well.
                        <br />
                        <br />
                        I wanted to take a moment to extend our deepest
                        gratitude to you and the entire Inteliphyle team for the
                        exceptional work you delivered on Market Overview.
                        Despite it being vacation time, your team went above and
                        beyond, delivering the report with exceptional
                        precision, insightful analysis, and remarkable attention
                        to detail.
                        <br />
                        <br />
                        The quality and depth of the report were extremely
                        valuable and informative for us, and we truly appreciate
                        the additional effort you put into this project as a
                        complimentary service. Your dedication, professionalism,
                        and quick turnaround are greatly appreciated and have
                        not gone unnoticed.
                        <br />
                        <br />
                        Once again, thank you for your remarkable support and
                        contribution. We look forward to continuing our
                        collaboration with such a fantastic and reliable
                        partner.
                        <br />
                        <br />
                        Best regards
                      </Typography>
                      <Typography
                        sx={{
                          color: "rgba(255, 102, 0, 1)",
                          fontSize: { xs: "0.8rem", sm: "1.1rem" },
                          fontWeight: "500",
                          paddingTop: "0.8rem",
                        }}
                      >
                        Business Insights Manager - JTI
                      </Typography>
                    </Box>
                  </Box>
                </SwiperSlide>

                <SwiperSlide>
                  <Box
                    sx={{
                      width: { xs: "90%", sm: "90%" },
                      height: { xs: "44rem", sm: "50.5rem", md: "36.5rem" },
                      overflow: "visible",
                      borderRadius: "1rem",
                      backgroundColor: "rgba(241, 241, 241, 1)",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      position: "relative",
                      margin: "0 auto",
                    }}
                  >
                    <Box
                      sx={{
                        width: { xs: "90%", sm: "90%" },
                        padding: { xs: "1rem 0rem", sm: "2.5rem 0rem" },
                      }}
                    >
                      <Typography
                        sx={{
                          textAlign: "left",
                          fontFamily: "Plus Jakarta Sans",
                          fontWeight: "300",
                          fontSize: { xs: "0.7rem", sm: "1rem" },
                          color: "#333333",
                        }}
                      >
                        Dear Prasun,
                        <br />
                        <br />
                        I'd like to congratulate you and the entire Inteliphyle
                        team for completing your first management presentation
                        for us. We appreciate all the time, effort, and thought
                        you have put behind building this first-of-its-kind
                        project, which is never easy for a new team to pull off.
                        Our team would like to use this instance to thank all
                        the project members for delivering this objective,
                        measurable, and forward looking project.
                        {/* <br />
                        <br />
                        I'd like to call out a few features for us to take
                        forward. */}
                        <br />
                        <br />
                        How this project contributed to our Marketing approach:
                        <ul
                          style={{
                            paddingLeft: "20px",
                            marginTop: "",
                            textAlign: "left",
                            fontFamily: "Plus Jakarta Sans",
                            fontWeight: "400",
                            fontSize: { xs: "0.5rem", sm: "0.8rem" },
                            color: "#333333",
                            paddingTop: "0.5rem",
                          }}
                        >
                          <Typography
                            sx={{
                              marginTop: "",
                              textAlign: "left",
                              fontFamily: "Plus Jakarta Sans",
                              fontWeight: "300",
                              fontSize: { xs: "0.65rem", sm: "0.8rem" },
                              color: "#333333",
                            }}
                          >
                            <li>
                              Clear measurement of activation impact of latest
                              events
                            </li>
                          </Typography>
                          <Typography
                            sx={{
                              marginTop: "",
                              textAlign: "left",
                              fontFamily: "Plus Jakarta Sans",
                              fontWeight: "300",
                              fontSize: { xs: "0.65rem", sm: "0.8rem" },
                              color: "#333333",
                            }}
                          >
                            <li>
                              Identification of improvement areas to convert
                              next events sharper, more precise in achieving
                              goals
                            </li>
                          </Typography>
                          <Typography
                            sx={{
                              marginTop: "",
                              textAlign: "left",
                              fontFamily: "Plus Jakarta Sans",
                              fontWeight: "300",
                              fontSize: { xs: "0.65rem", sm: "0.8rem" },
                              color: "#333333",
                            }}
                          >
                            <li>
                              Reiteration of importance of objectives behind an
                              event
                            </li>
                          </Typography>
                          <Typography
                            sx={{
                              marginTop: "",
                              textAlign: "left",
                              fontFamily: "Plus Jakarta Sans",
                              fontWeight: "300",
                              fontSize: { xs: "0.65rem", sm: "0.8rem" },
                              color: "#333333",
                            }}
                          >
                            <li>
                              Recommendations on event types, customizable to
                              the needs of the business
                            </li>
                          </Typography>
                        </ul>
                        <br />
                        We, as an organization, believe in continuous
                        improvement in our efforts, be it route-to-market or
                        impact assessment. And we think this project is stepping
                        towards the right direction even though it is in its
                        early days.
                        <br />
                        <br />
                        I would like to thank you again for making it happen.
                        Looking forward to more impactful collaboration in days
                        to come.
                        <br />
                        <br />
                        Kind regards
                      </Typography>
                      <Typography
                        sx={{
                          color: "rgba(255, 102, 0, 1)",
                          fontSize: { xs: "0.8rem", sm: "1.1rem" },
                          fontWeight: "500",
                          paddingTop: "0.8rem",
                        }}
                      >
                        Nishat Fahmida - JTI
                      </Typography>
                    </Box>
                  </Box>
                </SwiperSlide>

                <SwiperSlide>
                  <Box
                    sx={{
                      width: { xs: "90%", sm: "90%" },
                      height: { xs: "44rem", sm: "50.5rem", md: "36.5rem" },
                      overflow: "visible",
                      borderRadius: "1rem",
                      backgroundColor: "rgba(241, 241, 241, 1)",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      position: "relative",
                      margin: "0 auto",
                    }}
                  >
                    <Box
                      sx={{
                        width: { xs: "90%", sm: "90%" },
                        padding: { xs: "1rem 0rem", sm: "2.5rem 0rem" },
                      }}
                    >
                      <Typography
                        sx={{
                          textAlign: "left",
                          fontFamily: "Plus Jakarta Sans",
                          fontWeight: "300",
                          fontSize: { xs: "0.7rem", sm: "1rem" },
                        }}
                      >
                        Hi Team,
                        <br />
                        <br />
                        I wanted to take a moment to express our sincere
                        appreciation for the excellent work your team delivered
                        during the workshop. The insights gathered and the
                        innovative approaches presented were exactly what we
                        needed to enhance our understanding of consumer behavior
                        and engagement strategies.
                        <br />
                        <br />
                        We are confident that the outcomes will contribute
                        significantly to the development of our upcoming
                        campaigns.
                        <br />
                        <br />
                        Thank you once again for your hard work and dedication.
                        We look forward to continuing our collaboration and
                        achieving even greater results in the future.
                        <br />
                        <br />
                        Thanks
                      </Typography>
                      <Typography
                        sx={{
                          color: "rgba(255, 102, 0, 1)",
                          fontSize: { xs: "0.8rem", sm: "1.1rem" },
                          fontWeight: "500",
                          paddingTop: "0.8rem",
                        }}
                      >
                        Strategic Insights Manager - JTI
                      </Typography>
                    </Box>
                  </Box>
                </SwiperSlide>

                <SwiperSlide>
                  <Box
                    sx={{
                      width: { xs: "90%", sm: "90%" },
                      height: { xs: "44rem", sm: "50.5rem", md: "36.5rem" },
                      overflow: "visible",
                      borderRadius: "1rem",
                      backgroundColor: "rgba(241, 241, 241, 1)",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      position: "relative",
                      margin: "0 auto",
                    }}
                  >
                    <Box
                      sx={{
                        width: { xs: "90%", sm: "90%" },
                        padding: { xs: "1rem 0rem", sm: "2.5rem 0rem" },
                      }}
                    >
                      <Typography
                        sx={{
                          textAlign: "left",
                          fontFamily: "Plus Jakarta Sans",
                          fontWeight: "300",
                          fontSize: { xs: "0.7rem", sm: "1rem" },
                        }}
                      >
                        Thanks Prasun.
                        <br />
                        <br />
                        This analysis is really useful and this is something
                        which was beyond the scope of work. My sincere thanks to
                        you and your team for putting this together.
                        <br />
                        <br />
                        Kind regards
                        <br />
                      </Typography>
                      <Typography
                        sx={{
                          color: "rgba(255, 102, 0, 1)",
                          fontSize: { xs: "0.8rem", sm: "1.1rem" },
                          fontWeight: "500",
                          paddingTop: "0.8rem",
                        }}
                      >
                        Mufrad Morsaleen - JTI
                      </Typography>
                    </Box>
                  </Box>
                </SwiperSlide>
              </Swiper>
            </div>
          </div>
        </Box>

        <Box>
          <button
            className="custom-next-buttonn portfolio-btn-btnn"
            onClick={goNext}
          >
            <Box
              sx={{
                width: { xs: "2.6rem", sm: "3rem" },
                zIndex: "1",
              }}
            >
              <img src={RightArrow} alt="" width="100%" />
            </Box>
          </button>
        </Box>
      </Box>
    </Box>
  );
}

export default CustomerSlider;
